module.exports = __webpack_public_path__ + "img/4.ec1dfd83.svg";